module.exports = __webpack_public_path__ + "static/media/nptel.ca4f4d97.png";